import { Dialog, DialogContent } from "@material-ui/core";
import React from "react";

import LoadingSpinner from "../Utilities/LoadingSpinner";

// Loading
export default function LoadingModal(props: { show: boolean; onHide?: () => void }) {
  if (!props.show) return null;

  return (
    <Dialog open={props.show ? props.show : false} onClose={props.onHide} id="loading">
      <DialogContent
        style={{
          backgroundColor: "transparent",
          border: "none",
          height: 120,
          width: 120,
          padding: 0,
        }}
      >
        <LoadingSpinner isInsideLoadingModal={true} />
      </DialogContent>
    </Dialog>
  );
}
